import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { TextView } from 'src/core/ui/text.view';

interface RegionListViewProps extends ComponentViewProps<DataSet<RegionSummary>> {
	onItemDoubleClicked: (item?: RegionSummary) => void;
}

@observer
export class RegionListView extends React.Component<RegionListViewProps, {}> {
	constructor(props: Readonly<RegionListViewProps>) {
		super(props);
	}

	render() {
		const { model, onItemDoubleClicked, setBusy } = this.props;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'shortName',
				title: 'Code',
				dataIndex: 'code',
				filter: {
					field: 'code',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode="edit"
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				},
				render: (text, record: RegionSummary) => <Link to={`/general/regions/${record.id}`}>{text}</Link>,
			},
			{
				key: 'codeIso2',
				title: 'Code Iso2',
				dataIndex: 'codeIso2',
				filter: {
					field: 'codeIso2',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							mode="edit"
							label={null}
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName'
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={onItemDoubleClicked}
						hierarchyParent={['parentRegionId']}
						hierarchyHasChildren={(item) => item.hasChildren}
						hierarchyId={['id']}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/regions/list/region-list.view.tsx